'use strict';
import { ChangeDetectionStrategy, Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { get } from 'lodash';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

import { AgregationService } from '@ispm-client/modules/aggregator/services/aggregator.service';
import { IoptionElemet } from '@ispm/shared/interfaces/IoptionElemet';

@Component({
  selector: 'gen-popup-action',
  templateUrl: './popup-action.component.html',
  styleUrls: ['./popup-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupActionComponent implements OnInit {
  public callback: (model) => Observable<Response>;
  public form: any;
  public formData: any = { };
  public formName: string;
  public inputClass: string = 'calendar-style';
  public isValid: boolean;
  public payload: { formName: string, options: IoptionElemet[] };
  public submitted: boolean;
  public tunnel$: Subject<any>;
  public updating: boolean;

  constructor(
    private _notificationMessageService: NotificationMessageService,
    private _aggregationService: AgregationService,
    private _changeDetector: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.formName = this.payload['formId'];
    this.formData = this.payload['formData'];
    this.formData.formId = this.formName;

    this.tunnel$
      .asObservable()
      .filter(value => value.emitter !== 'child')
      .subscribe(next => {
        next.value && this.submit();
      });
  }

  updateForm(form) {
    this.formData = form;
  }

  updateValidate(validate: boolean) {
    this.isValid = validate;
  }

  submit() {
    this.submitted = true;

    if (!(this.isValid)) {
      return;
    }

    this.updating = true;
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();

    const context = [{ reference: this.formData.patientId, resourceType: 'Patient'}];
    delete this.formData['patientId'];

    this._aggregationService.saveFormData(this.formName, this.formData, context) // If this.formData contain parameter named 'id' it will be the record key for searching the record to update
      .subscribe((saveResponse) => {
        if (get(saveResponse, 'code') === 2 ) { // 2 means that changes were saved (not just that that sav request was sent)
          if (saveResponse.response && saveResponse.response[0] && saveResponse.response[0][0] && saveResponse.response[0][0].meta) {
            this.formData.meta.versionId = saveResponse.response[0][0].meta.versionId;
            this.formData.meta.lastUpdated = saveResponse.response[0][0].meta.lastUpdated;
          }

          this.tunnel$.next({ status: 1, emitter: 'child', value: this.formData});
          this._notificationMessageService.success('Changes updated Successfully');
          this.updating = false;
        } else if (get(saveResponse, 'code') === 4 ) {
          this._notificationMessageService.error('Unable to updated changes');
          this.updating = false;
        }
      });
  }
}

